import { ApplyButton } from "./ApplyButton";
import { Body } from "./Body";
import { Buttons } from "./Buttons";
import { CancelButton } from "./CancelButton";
import { Checkbox } from "./Checkbox";
import { Container } from "./Container";
import { Header } from "./Header";
import { Label } from "./Label";
import { Optional } from "./Optional";
import { TextField } from "./TextField";

export const Panel = Object.assign(Container, {
  Body,
  Buttons,
  Optional,
  ApplyButton,
  CancelButton,
  Header,
  Label,
  TextField,
  Checkbox,
});
